<template>
  <div class=''>
      <Header :widthmun='windowWidth' @getReportList="getReportList"/>

      <div class="new_box">
          <div class="container sp">
              <el-row>
                  <el-col :span="24">
                      <div class="col_list">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{$t('home.home')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{$t('rename.title')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{mename}}</el-breadcrumb-item>
                          </el-breadcrumb>
                      </div>
                      <h2 class="showtitle" v-html="mename"></h2>
                  </el-col>
              </el-row>
            
          </div>
      </div>

        <div class="content">
            <div class="container newcont">
                <el-row>
                    <el-col>
                        <div class="cont_box">

                            <el-row>

                                <el-col style="background: #fff;"  class="el-col-box" :xs="24" :sm="24" :md="8" :lg="7" :xl="7" >
                                    <el-collapse v-if="windowWidth >= 1024" v-model="activeName" accordion>
                                        <el-collapse-item :class="activeName=='1'?'activeheader':''" :title="$t('rename.title1')" name="1">
                                            <div v-for="(item,index) in reportList" :key="index">
                                              <div v-if="lang=='en-US'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenu(item)">{{item.titleEn}}</el-link>
                                              </div>
                                              <div v-if="lang=='zh-CN'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenu(item)">{{item.titleZh}}</el-link>
                                              </div>
                                            </div>
                                        </el-collapse-item>
                                        <el-collapse-item :class="activeName=='2'?'activeheader':''" :title="$t('rename.title2')" name="2">
                                            <div v-for="(item,index) in chinaReport" :key="index">
                                              <div v-if="lang=='en-US'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenu(item)">{{item.titleEn}}<span v-if="item.releaseDateEn">  -  </span>{{item.releaseDateEn}}</el-link>
                                              </div>
                                              <div v-if="lang=='zh-CN'">
                                                <el-link :underline="false" :class="activeclass==item.id?'active':''" @click="changemenu(item)">{{item.titleZh}}<span v-if="item.releaseDateZh">  -  </span>{{formatDates(item.releaseDateZh)}}</el-link>
                                              </div>
                                            </div>
                                        </el-collapse-item>
                                       
                                        <!-- <el-collapse-item :class="activeName=='3'?'activeheader':''" :title="$t('rename.title3')" name="3">
                                            <div>
                                                <el-link :underline="false">{{$t('rename.mename4')}}</el-link>
                                            </div>
                                        </el-collapse-item> -->
                                    </el-collapse>
                                </el-col>

                                <div v-for="(item,index) in arrlist" :key="index">
                                 <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == item.id" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3 style="margin-bottom:10px;" v-if="lang == 'en-US'">{{item.titleEn}}</h3>
                                       <h3 style="margin-bottom:10px;" v-if="lang == 'zh-CN'">{{item.titleZh}}</h3>
                                       <div style="display:flex;justify-content:space-between;margin-top:20px;">
                                            <p class="h4" style="font-weight:500;font-size:">{{item.sourceText}}</p>
                                            <p class="h4" style="color:#7E7F93;font-weight:500" v-if="lang == 'en-US'">{{item.releaseDateEn}}</p>
                                            <p class="h4" style="color:#7E7F93;font-weight:500" v-if="lang == 'zh-CN'">{{formatDates(item.releaseDateZh)}}</p>
                                       </div>
                                       
                                       
                                       <div v-if="lang == 'en-US'" v-html="item.textEn"></div>
                                       <div v-if="lang == 'zh-CN'" v-html="item.textZh"></div>

                                       <p style="margin-top:30px">{{$t('rename.m7.c5')}}<a class="bolang_a" @click="changedialog(item)" style="margin-left: 3px;color:#551aa9;cursor:pointer" target="download"> {{$t('rename.m7.c6')}}</a>{{  $t('rename.m7.c7')}}</p>
                                       
                                        <el-dialog width='700px' :append-to-body='true'  :visible.sync="dialogWeekVisible">
                                            <p style="text-align:center;">
                                                <img src="../../assets/img/gerenxinxi.png" style="text-align:center;margin:0 auto" alt="">
                                            </p>
                                            
                                            <p style="text-align:center;" class="dialog_box_p">{{$t('rename.m2.c15')}}</p>
                                            <el-form style="margin:0 auto;width:65%;margin-top:40px" :model="form" :rules="rules" id="frmDownloadReport" ref="ruleForm" label-width="100px" method="POST">
                                                <el-form-item :label="$t('rename.m2.c16')" prop="name">
                                                    <el-input v-model="form.name" name="name" clearable></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('rename.m2.c17')" prop="company">
                                                    <el-input v-model="form.company" name="company" clearable></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('rename.m2.c18')" prop="email">
                                                    <el-input v-model="form.email" name="email" clearable></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('rename.m2.c16')" prop="Report ID" v-show="false" >
                                                    <el-input v-model="form.reportId" name="reportId"  ></el-input>
                                                </el-form-item>
                                            </el-form>
                                                       
                                                
                                            <div slot="footer" class="dialog-footer">
                                                <el-button class="dia_box" @click="dialogWeekVisible = false">{{$t('rename.m2.c19')}}</el-button>
                                                <el-button class="bg_dia_box dia_box" type="primary"  @click="submitForm('ruleForm')">{{$t('rename.m2.c20')}}</el-button>
                                            </div>
                                        </el-dialog>
                                   </div>
                                 </el-col>
                                </div>
                                
                                
                            </el-row>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

      <Footer :widthmun='windowWidth'/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
import report from '@/api/report.js'
import { mapState, mapActions } from "vuex";
import { getDefaultStartTime, formatDates } from "@/util/date";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { Header, Footer },
  data() {
    // 这里存放数据
    return {
      parmaid: "",
      lang:this.$i18n.locale,
      arrlist:[],
      reportList:[],
      chinaReport:[],
      checked: false,
      datedisabled: true,
      queryid:'',
      activeName: "1",
      mename: "",
      activeclass: "",
      form: {
        name: "",
        company: "",
        email: "",
        reportId: "2",
      },
      calculatorForm: {
        dateOfMining: "Fri Jan 01 2021 00:00:00 GMT+0800 (中国标准时间)",
        manufacturerId: null,
        minerId: null,
        location: null,
      },

      formLabelAlign: {},
      formDialogData:{},
      dialogFormVisible: false,
      dialogWeekVisible: false,
      formLabelWidth: "120px",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      rules: {
        name: [
          {
            required: true,
            message: "Please enter your name",
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "Please enter the company name",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Please enter email", trigger: "blur" },
          {
            type: "email",
            message: "Please enter the correct email address",
            trigger: ["blur"],
          },
        ],
      },
      rulesLabelAlign: {
        HP: [
          {
            required: true,
            message: "Please enter Hash Rate",
            trigger: "blur",
          },
        ],
        P: [
          {
            required: true,
            message: "Please enter Reference Power",
            trigger: "blur",
          },
        ],
        PUE: [
          {
            required: true,
            message: "Please enter Data center PUE",
            trigger: "blur",
          },
        ],
        pps: [
          {
            required: true,
            message: "Please enter Pay per share",
            trigger: "blur",
          },
        ],
        EF: [
          {
            required: true,
            message: "Please enter Emission Factor",
            trigger: "blur",
          },
        ],
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      calculatorBindData: (state) => state.miner.bindData,
      calculatorRequestData: (state) => state.miner.requestData,
    }),
  },
  // 监控data中的数据变化
  watch: {
    windowHeight(val) {
      let that = this;
    },
    windowWidth(val) {
      let that = this;
      this.windowWidth = val;
    },
    '$i18n.locale'(val) {
      this.lang = val
    },
    '$route.query.id'(val) {
      this.queryid = val
    },
  },
  // 方法集合
  methods: {
    ...mapActions("miner", [
      "getManufacturerList",
      "getMinerListByManufacturerId",
      "getDifficultyByDate",
      "getPPSByDate",
      "getEmissionFactorListByYear",
      "calculate",
    ]),
    ...mapActions("report", ["saveReport"]),

    submitForm(formName) {
      this.form.reportId = this.formDialogData.id;
      let self = this;
      self.$refs[formName][0].validate((valid) => {
        if (valid) {
          // 接口请求碳中和
          self.saveReport(self.form);
          self.dialogFormVisible = false;
          self.dialogWeekVisible = false;

          self.$message({
            message: self.$t("rename.m2.c24"),
            type: "success",
          });
          self.initialReportForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changedialog(item){
      this.formDialogData = {}
      this.formDialogData = item
      this.dialogWeekVisible = true
    },
    formatDates: function (dataVal) {
      if (null == dataVal) {
        return "";
      }
      return formatDates(dataVal);
    },
    getReportList(val){
          let arr = val
          this.arrlist = val
          // this.parmaid = this.$route.query.id;
          this.chinaReport = []
          this.reportList = []
          for(let i = 0 ; i < arr.length ; i++){
            if(arr[i].categoryId == 1){
              this.chinaReport.push(arr[i])
            }else{
              this.reportList.push(arr[i])
            }
            if(this.parmaid){
              if(this.parmaid/1 == arr[i].id){
                this.parmaid = arr[i].id
                this.changemenu(arr[i]);
              }
            }else{
              this.parmaid = arr[0].id
              this.changemenu(arr[0]);
            }
          }
    },
    changemenu(row) {
      this.mename = "";
      // if(row.id == this.parmaid){
        if(row.categoryId == 1){
            if(this.lang == 'en-US'){
              if(row.releaseDateEn){
                this.mename = row.titleEn+' - '+row.releaseDateEn;
              }else{
                this.mename = row.titleEn;
              }
            }else{
              if(row.releaseDateZh){
                this.mename = row.titleZh+' - '+this.formatDates(row.releaseDateEn);
              }else{
                this.mename = row.titleZh;
              }
            }
            this.activeName = '2'
        }else{
            if(this.lang == 'en-US'){
              if(row.releaseDateEn){
                this.mename = row.titleEn;
              }else{
                this.mename = row.titleEn;
              }
            }else{
              if(row.releaseDateZh){
                this.mename = row.titleZh;
              }else{
                this.mename = row.titleZh;
              }
            }
            this.activeName = '1'
        }
      // }else{

      // }
      
      
      
      this.parmaid = row.id;
      this.activeclass = row.id;
    },
    changetype() {
      // this.mename = "";
      // console.log(this.parmaid)
      // if (this.parmaid == "1") {
      //   this.mename = this.$t("rename.mename1");
      //   this.activeName = "1";
      //   this.changemenu(this.mename, this.parmaid);
      // }
      // if (this.parmaid == "2") {
      //   this.mename = this.$t("rename.mename2");
      //   this.activeName = "1";
      //   this.changemenu(this.mename, this.parmaid);
      // }
      // if (this.parmaid == "3") {
      //   this.mename = this.$t("rename.mename5");
      //   this.activeName = "2";
      //   this.changemenu(this.mename, this.parmaid);
      // }
      // if (this.parmaid == "6") {
      //   this.mename = this.$t("rename.mename6");
      //   this.activeName = "1";
      //   this.changemenu(this.mename, this.parmaid);
      // }
      // if (this.parmaid == "7") {
      //   this.mename = this.$t("rename.mename7");
      //   this.activeName = "1";
      //   this.changemenu(this.mename, this.parmaid);
      // }
    },
    changeManufacturer() {
      let manufacturerId = this.calculatorForm.manufacturerId;
      this.calculatorForm.minerId = null;

      // 重选厂商时候，清空算力和瓦数
      this.calculatorRequestData.HP = 0;
      this.calculatorRequestData.P = 0;
      this.getMinerListByManufacturerId({ manufacturerId });
    },
    changeMiner() {
      let minerId = this.calculatorForm.minerId;
      let list = this.calculatorBindData.minerList.filter((s) => {
        return s.id == minerId;
      });
      let item = list[0];
      this.calculatorRequestData.HP = item.hashRate;
      this.calculatorRequestData.P = item.power;
    },
    changedatedisabled() {
      if (this.checked) {
        this.datedisabled = false;
      } else {
        this.datedisabled = true;
      }
    },
    changeDateOfMining() {
      let request = { date: this.calculatorForm.dateOfMining };
      this.getDifficultyByDate(request);
      this.getPPSByDate(request);

      // rebind localtion list
      this.calculatorBindData.location = null;

      if (this.calculatorForm.dateOfMining) {
        let year = this.calculatorForm.dateOfMining.getFullYear();
        this.getEmissionFactorListByYear({ year });
      } else {
        this.getEmissionFactorListByYear({});
      }
    },
    changeLocation() {
      let location = this.calculatorForm.location;
      let list = this.calculatorBindData.emissionFactorList.filter((s) => {
        return s.location == location;
      });
      let item = list[0];
      this.calculatorRequestData.EF = item.efValue;
    },
    initialReportForm() {
      this.form.name = "";
      this.form.company = "";
      this.form.email = "";
    },
    submit(ruleLabelAlign) {
      this.$refs[ruleLabelAlign].validate((valid) => {
        if (valid) {
          this.calculate(this.calculatorRequestData);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getManufacturerList();
    this.getDifficultyByDate({});
    this.getPPSByDate({});
    this.getEmissionFactorListByYear({});
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
    this.parmaid = this.$route.query.id;
    this.$bus.$on("changeid", (id) => {
      for(let i = 0 ; i < this.arrlist.length ; i++){
        if(id/1 == this.arrlist[i].id){
          this.parmaid = this.arrlist[i].id
          this.changemenu(this.arrlist[i]);
        }
      }
    });
    this.changetype();
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        this.windowHeight = window.fullHeight; // 高
        this.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box {
  height: 420px;
  background: url("../../assets/img/btcbj.png") no-repeat;
  background-size: cover;
  font-size: 16px;
  color: #7d91aa;
}
::v-deep .el-breadcrumb__inner {
  color: #c8c8c8 !important;
  font-size: 16px !important;
}
::v-deep .date_box {
  .el-input__suffix {
    transform: translateX(-50px) !important;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 145px;
  }
}
.sp {
  padding-top: 90px;
  padding-bottom: 90px;
  .el-row {
    margin-top: 10%;
  }
  .col_list {
    padding: 10px;
    margin-bottom: 20px;
  }
}
.showtitle {
  color: #fff !important;
  font-size: 40px;
  line-height: 50px;
}

.span_box {
  font-weight: bold;
  color: #000;
}
.fuhao_box {
  font-size: 12px;
  padding-bottom: 10px;
}
.fuhao_box_w {
  font-size: 12px;
  padding-top: 10px;
}

.content {
  margin-top: -35px;
  min-height: 700px;

  .cont_box {
    padding: 20px;
    .el-row {
      margin-top: -20px;
    }
  }
  .h5 {
    font-size: 19px;
    font-family: inherit;
  }
  h6 {
    font-size: 14px;
    margin-bottom: 25px;
    font-weight: normal;
  }
  p {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 26px;
    font-family: ArialMT;
  }
  .new_box_list {
    padding-top: 10px;
    padding-bottom: 20px;
  }
}
.comput_p {
  font-size: 22px !important;
  margin-bottom: 40px !important;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  color: #21212a !important;
}
::v-deep .comput_box {
  .el-form-item__label {
    font-size: 16px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #21212a;
  }
  .el-icon-arrow-up:before {
    content: url("../../assets/img/snajiao.png");
  }
}
.flex_box {
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    font-family: ArialMT;
    color: #5d5d5d;
    line-height: 14px;
    margin: 0;
    padding-left: 10px;
  }
}

.el-col-box {
  border: 0.1px solid #fff;
  border-radius: 5px;
  margin-right: 30px;
  box-shadow: 0px 5px 15px rgba(136, 136, 136, 0.2);
}
::v-deep .el-collapse-item__header {
  padding-left: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #21212a;
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
::v-deep .el-collapse-item__header:focus {
  background: #218cba;
  color: #fff;
}
::v-deep .el-collapse-item__header:focus,
.el-collapse,
.el-col-box {
  border: none !important;
}
::v-deep .el-collapse-item__content {
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #edeef3;
  .el-link {
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 35px;
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
    color: #5d5d5d;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis !important;
    white-space: nowrap;
    text-decoration: none;
  }
  .el-link:hover {
    color: #218cba !important;
  }
  .active {
    color: #218cba !important;
  }
}
::v-deep .activeheader {
  .el-collapse-item__header {
    background: #218cba;
    color: #fff;
  }
}
.cont_box_col {
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
  padding: 30px 20px 20px 20px;
  h3 {
    color: #218cba !important;
    margin: 28px 0;
    font-size: 32px;
    line-height: 42px;
    padding: 10px 0 10px 0;
    font-weight: normal;
  }
  .h5 {
    color: #21212a !important;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 1px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: 800;
  }
  .h4 {
    font-weight: 800;
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    line-height: 28px;
  }
}
.icon_box {
  padding: 30px 30px 30px 10px;
  p {
    padding-top: 10px;
    padding-left: 20px;
  }
}
.li_box {
  display: flex;
  i:after {
    content: url(../../assets/img/i1.png);
    margin-right: 9px;
  }
}
.color_p {
  color: #218cba;
}
.hp {
  color: #21212a;
  font-weight: 800;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 27px;
}
.dialog_box_p {
  font-size: 24px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #161616;
  line-height: 32px !important;
}
.dialog-footer {
  text-align: center;
  padding-bottom: 30px;
}
.dia_box {
  padding-left: 30px;
  padding-right: 30px;
}
.bg_dia_box {
  background: #218cba;
}
::v-deep .el-form-item__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8d8d8d;
}
@media screen and (min-width: 280px) and (max-width: 1023px) {
  /deep/.el-collapse-item__header {
    font-size: 24px !important;
    height: 80px;
  }
  /deep/.el-collapse-item__content .el-link {
    font-size: 24px !important;
    line-height: 60px;
  }
  /deep/.el-collapse-item__content p {
    font-size: 24px !important;
    line-height: 60px;
  }
}
// aaa
</style>
